import { render, staticRenderFns } from "./become-an-environmental-steward.vue?vue&type=template&id=4dd55b2a&"
import script from "./become-an-environmental-steward.vue?vue&type=script&lang=js&"
export * from "./become-an-environmental-steward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports